export const adjustColor = (color, percent = 0) => {
  // Remove hash if present
  color = color.replace("#", "");

  // Convert short hex (e.g. #03F) → long hex (#0033FF)
  if (color.length === 3) {
    color = color
      .split("")
      .map((c) => c + c)
      .join("");
  }

  // Parse to integer
  const num = parseInt(color, 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  // Adjust brightness
  const adjust = (channel) =>
    Math.min(255, Math.max(0, channel + (channel * percent) / 100));

  r = Math.round(adjust(r));
  g = Math.round(adjust(g));
  b = Math.round(adjust(b));

  // Recombine to hex
  return `#${((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
    .toUpperCase()}`;
};
